import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import DataListContainer from '../../components/layout/DataListContainer';
import ListSkeleton from '../../components/skeletons/ListSkeleton';
import { timeAgo } from '../../utils/dateUtils';
import { ProjectsIcon} from '../../components/Icons/svgIcons';
import {ICONS} from "../../constants/imageConstants";

const ProjectPerformanceChart = ({ forms }) => {
  const navigate = useNavigate();
  
  const sortedForms = useMemo(() => {
    if (!Array.isArray(forms)) return [];
    return [...forms]
      .sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at))
      .slice(0, 5);
  }, [forms]);

  const handleFormClick = (formId) => {
    navigate(`/forms/fill/${formId}`);
  };

  return (
    <div className="rounded-xl border-2 border-gray-200 shadow-sm mb-6 overflow-hidden">
      <div className="px-5 py-4 border-b-2 border-gray-200 bg-gray-50/30">
        <h3 className="text-gray-900 text-sm font-bold uppercase tracking-wide">Recently Updated Forms</h3>
      </div>
      
      <DataListContainer
        isLoading={!forms}
        data={sortedForms}
        skeletonComponent={<div className="p-4"><ListSkeleton items={3} /></div>}
        emptyStateContainerClassName="p-6"
        emptyStateProps={{
          title: "No Forms Found",
          message: "No active forms available to display."
        }}
      >
        <div className="divide-y divide-gray-200">
          {sortedForms.map((form) => (
            <div 
              key={form.id} 
              onClick={() => handleFormClick(form.id)}
              className="px-5 py-3.5 transition-colors hover:bg-gray-50 cursor-pointer group"
            >
              <div className="flex justify-between items-center gap-3">
                <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="w-9 h-9 rounded-lg icon-bg-theme flex items-center justify-center flex-shrink-0">
                     <ProjectsIcon className="w-5 h-5 icon-theme" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-semibold text-gray-900 truncate group-hover:text-[var(--btn-primary-bg)] transition-colors" title={form.title}>
                      {form.title}
                    </p>
                    <div className="flex items-center gap-2 mt-0.5">
                        <span className="text-[10px] font-medium text-gray-400 uppercase tracking-wide">Updated {timeAgo(form.updated_at || form.created_at)}</span>
                    </div>
                  </div>
                </div>
                
                 <img src={ICONS.ARROW_RIGHT} alt='arrow-right '/>
              </div>
            </div>
          ))}
        </div>
      </DataListContainer>
    </div>
  );
};

export default ProjectPerformanceChart;